"use client";

import { useEffect, useMemo } from "react";

import { MODELS } from "../constants";
import SingleSelect from "../SingleSelect";

const getIcon = (value: number) => {
  switch (value) {
    case 1:
      return (
        <svg
          width="11"
          height="11"
          viewBox="0 0 11 11"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="2"
            y="2"
            width="7"
            height="7"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            rx="1"
          />
        </svg>
      );
    case 2:
      return (
        <svg
          width="18"
          height="11"
          viewBox="0 0 18 11"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="2"
            y="2"
            width="7"
            height="7"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            rx="1"
          />
          <rect
            x="9"
            y="2"
            width="7"
            height="7"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            rx="1"
          />
        </svg>
      );
    case 3:
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="2"
            y="2"
            width="7"
            height="7"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            rx="1"
          />
          <rect
            x="9"
            y="2"
            width="7"
            height="7"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            rx="1"
          />
          <rect
            x="2"
            y="9"
            width="7"
            height="7"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            rx="1"
          />
        </svg>
      );
    case 4:
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="2"
            y="2"
            width="7"
            height="7"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            rx="1"
          />
          <rect
            x="9"
            y="2"
            width="7"
            height="7"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            rx="1"
          />
          <rect
            x="2"
            y="9"
            width="7"
            height="7"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            rx="1"
          />
          <rect
            x="9"
            y="9"
            width="7"
            height="7"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            rx="1"
          />
        </svg>
      );
    default:
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="2"
            y="2"
            width="7"
            height="7"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            rx="1"
          />
          <rect
            x="9"
            y="2"
            width="7"
            height="7"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            rx="1"
          />
          <rect
            x="2"
            y="9"
            width="7"
            height="7"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            rx="1"
          />
          <rect
            x="9"
            y="9"
            width="7"
            height="7"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            rx="1"
          />
        </svg>
      );
  }
};

interface TotalImagesSelectProps {
  selectedModel: string;
  totalImages: number;
  setTotalImages: (value: number) => void;
  isSubscribed?: boolean;
}

const TotalImagesSelect: React.FC<TotalImagesSelectProps> = ({
  selectedModel,
  totalImages,
  setTotalImages,
  isSubscribed = false,
}) => {
  const availableTotals = useMemo(() => {
    const model = MODELS.find((m) => m.name === selectedModel);
    const baseImageTotals = model?.includedImageTotals || [1, 2, 4];

    if (selectedModel === "imagen-4" && !isSubscribed) {
      return [1];
    }

    return baseImageTotals;
  }, [selectedModel, isSubscribed]);

  useEffect(() => {
    if (!availableTotals.includes(totalImages)) {
      setTotalImages(1);
    } else if (availableTotals.includes(4)) {
      setTotalImages(4);
    }
  }, [availableTotals]);

  return (
    <SingleSelect
      selected={{
        value: totalImages.toString(),
        label: totalImages.toString(),
        icon: (
          <div className="tw:grid tw:place-items-center tw:text-primary-red tw:w-4 tw:h-4">
            {getIcon(totalImages)}
          </div>
        ),
      }}
      options={[1, 2, 4].map((val) => ({
        value: val.toString(),
        label: val.toString(),
        icon: (
          <div className="tw:grid tw:place-items-center tw:text-primary-red tw:w-4 tw:h-4">
            {getIcon(val)}
          </div>
        ),
        disabled: !availableTotals.includes(val),
      }))}
      onSelect={(value: string) => setTotalImages(parseInt(value))}
      label="Images"
      className="tw:w-[77px]"
    />
  );
};

export default TotalImagesSelect;
